/**
 *  @class
 *  @function SectionTabs
 */

if (!customElements.get("section-tabs")) {
  class SectionTabs extends HTMLElement {
    constructor() {
      super();
      this.section = this.closest(".shopify-section");
    }
    connectedCallback() {
      this.buttons = Array.from(this.querySelectorAll("button"));
      this.targetEls = Array.from(
        this.section.querySelectorAll(".section-tab")
      );

      this.buttons.forEach((button, i) => {
        const target = button.dataset.target;
        button.addEventListener("click", (event) => {
          if (button.classList.contains("active")) {
            event.preventDefault();
            return;
          }

          [].forEach.call(this.buttons, function (el) {
            el.classList.remove("active");
          });

          button.classList.add("active");

          this.targetEls.forEach((el) => {
            el.classList.remove("active");
          });

          const targetEl = this.section.querySelector(`#${target}`);
          if (targetEl) {
            targetEl.classList.add("active");

            // Flickity inside inactive tabs skips resize to avoid miscalculating
            // height in a hidden CSS grid cell. Reconcile now that the tab is
            // active.
            const carouselHost = targetEl.querySelector(
              "product-recommendations, recently-viewed-products"
            );
            if (carouselHost?.flkty) {
              carouselHost.flkty.resize();
            }
          }

          event.preventDefault();
        });
      });
    }
  }
  customElements.define("section-tabs", SectionTabs);
}
